import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import { popupPosition, popups } from '../../views/Handling/Handling.model';

const modeColors = {
	drift: {
		background: '#FABE2C',
		text: '#000000',
	},
	comfort: {
		background: '#1782FF',
		text: '#FFFFFF',
	},
	sport: {
		background: '#EB1818',
		text: '#FFFFFF',
	},
};

const StyledHoverBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: opacity 0.3s ease;
	z-index: 0;

	background-image: radial-gradient(
		circle at center,
		rgba(255, 255, 255, 0.1) 0%,
		rgba(255, 255, 255, 0) 100%
	);
`;

const StyledDot = styled.div`
	position: absolute;
	top: 50%;
	left: -35px;
	transform: translateY(-50%);
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: #ffffff;
	opacity: 0;
	transition: opacity 0.3s ease;
`;

const StyledContainer = styled.div<{ $selected?: boolean }>`
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 58px;

	${(props) =>
		props.$selected &&
		css`
			${StyledDot}, ${StyledHoverBackground} {
				opacity: 1;
			}
		`}

	&:hover {
		${StyledHoverBackground} {
			opacity: 1;
		}
	}
`;

const StyledButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;
	z-index: 1;
`;

const StyledTextLabel = styled(Text)<{
	$hover?: boolean;
	$selected?: boolean;
}>`
	color: #ffffff;
	font-size: 16px;
	font-weight: ${(props) => (props.$hover || props.$selected ? 700 : 400)};
	opacity: ${(props) => (props.$hover || props.$selected ? 1 : 0.5)};
	z-index: 1;
	transition: all 0.3s ease;
`;

const StyledButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.1);
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

const StyledActiveButton = styled(StyledButton)<{ $active?: boolean }>`
	background-color: ${(props) => props.$active && '#2D70DA'};
`;

const StyledRemoveButton = styled(StyledButton)`
	background-color: #c71e1e;
`;

const StyledPopupWrapper = styled.div`
	position: absolute;
	width: 100%;
	z-index: 5;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.popup-enter,
	&.hint-enter {
		opacity: 0;
	}

	&.popup-enter-active,
	&.popup-enter-done,
	&.popup-exit,
	&.hint-enter-active,
	&.hint-enter-done,
	&.hint-exit {
		opacity: 1;
	}

	&.popup-exit-active,
	&.hint-exit-active {
		opacity: 0;
	}
`;

const StyledPopupContainer = styled.div<{ $activePopup: popups }>`
	position: absolute;
	//top: 50px;
	right: ${(props) => popupPosition[props.$activePopup]}px;
	z-index: 6;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.9);

	${Text} {
		color: #000000;
		font-size: 14px;
		font-weight: 400;
	}
`;

const StyledInfoHintContainer = styled.div`
	position: absolute;
	//top: calc(50% + 25px);
	left: 135px;
	z-index: 2;
	display: flex;
	flex-direction: column;
	row-gap: 20px;
	width: 340px;
	padding: 20px;
	background-color: rgba(255, 255, 255, 0.9);
	border-radius: 10px;
`;

const StyledInfoHintRowContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledMode = styled.div<{ $mode: 'sport' | 'drift' | 'comfort' }>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	padding: 0 5px;
	background-color: ${(props) => modeColors[props.$mode].background};
	border-radius: 6px;

	${Text} {
		color: ${(props) => modeColors[props.$mode].text};
		font-size: 12px;
		font-weight: 500;

		&::first-letter {
			text-transform: capitalize;
		}
	}
`;

const StyledInfoHintAuthorContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 12px;

	${Text} {
		color: #000;
		font-size: 14px;
		font-weight: 500;
	}

	img {
		user-select: none;
		pointer-events: none;
		filter: invert(100%);
	}
`;

export {
	StyledHoverBackground,
	StyledDot,
	StyledContainer,
	StyledButtonsContainer,
	StyledTextLabel,
	StyledButton,
	StyledActiveButton,
	StyledRemoveButton,
	StyledPopupContainer,
	StyledInfoHintContainer,
	StyledInfoHintRowContainer,
	StyledMode,
	StyledInfoHintAuthorContainer,
	StyledPopupWrapper,
};
